import { useCallback, useRef, useState } from 'react';
import type { SwiperRef } from 'swiper/react';

export const useParkingSlideManagement = () => {
    const swiperRef = useRef<SwiperRef>(null);
    const [isDisabledPrev, setIsDisabledPrev] = useState(true);
    const [isDisabledNext, setIsDisabledNext] = useState(true);

    const updateNavigationState = useCallback(() => {
        const swiper = swiperRef.current?.swiper;
        if (!swiper) return;
        setIsDisabledPrev(swiper.isBeginning);
        setIsDisabledNext(swiper.isEnd);
    }, []);

    const handleSlidePrev = useCallback(() => {
        const swiper = swiperRef.current?.swiper;
        if (!swiper) return;
        const visibleCount = swiper.slidesPerViewDynamic();
        const targetIndex = Math.max(0, swiper.activeIndex - visibleCount);
        swiper.slideTo(targetIndex);
    }, []);

    const handleSlideNext = useCallback(() => {
        const swiper = swiperRef.current?.swiper;
        if (!swiper) return;
        const visibleCount = swiper.slidesPerViewDynamic();
        const targetIndex = Math.min(swiper.slides.length - 1, swiper.activeIndex + visibleCount);
        swiper.slideTo(targetIndex);
    }, []);

    const resetSlidePosition = useCallback(() => {
        const swiper = swiperRef.current?.swiper;
        if (!swiper) return;
        swiper.slideTo(0);
    }, []);

    return {
        swiperRef,
        isDisabledPrev,
        isDisabledNext,
        handleSlidePrev,
        handleSlideNext,
        updateNavigationState,
        resetSlidePosition,
    };
};
